import { Sparkles } from "lucide-react";

export default function Logo({ size = 28, withText = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="lx-logo">
      <div
        className="flex items-center justify-center rounded-lg"
        style={{
          width: size + 8,
          height: size + 8,
          background: "linear-gradient(135deg, #00AEEF 0%, #008CBE 100%)",
          boxShadow: "0 4px 14px rgba(0,174,239,0.30)",
        }}
      >
        <Sparkles size={size - 6} color="#fff" strokeWidth={2.2} />
      </div>
      {withText && (
        <div className="leading-none">
          <div
            style={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, fontSize: 17, letterSpacing: "-0.02em", color: "#0F172A" }}
          >
            Limpio<span style={{ color: "#00AEEF" }}>Express</span>
          </div>
          <div className="text-[10px] tracking-[0.18em] uppercase font-semibold mt-0.5" style={{ color: "#94A3B8" }}>
            QR Check System
          </div>
        </div>
      )}
    </div>
  );
}
